import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BuyersAccessControlDialogComponent } from 'src/app/buyers/buyers-access-control-dialog/buyers-access-control-dialog.component';
import { BuyersConfirmOtpDialogComponent } from 'src/app/buyers/buyers-confirm-otp-dialog/buyers-confirm-otp-dialog.component';
import { BuyersEditCardDialogComponent } from 'src/app/buyers/buyers-edit-card-dialog/buyers-edit-card-dialog.component';
import { BuyersEditDialogComponent } from 'src/app/buyers/buyers-edit-dialog/buyers-edit-dialog.component';
import { BuyersRequestsDialogComponent } from 'src/app/buyers/buyers-requests-dialog/buyers-requests-dialog.component';
import { BuyersSetBlockByAdminDialogComponent } from 'src/app/buyers/buyers-set-block-by-admin-dialog/buyers-set-block-by-admin-dialog.component';
import { Buyer, BuyersService } from 'src/app/core/buyers.service';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-buyer-details-header',
  templateUrl: './buyer-details-header.component.html',
  styleUrls: ['./buyer-details-header.component.scss'],
})
export class BuyerDetailsHeaderComponent {
  @Input() buyer_id?: string | null;

  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() tab_change: EventEmitter<string> = new EventEmitter<string>();

  buyer?: Buyer;
  is_read_running = false;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private buyers_service: BuyersService,
    private error_service: ErrorService,
    private dialog_service: DialogService,
  ) {}

  ngOnInit(): void {
    this.readBuyer(this.buyer_id as string);
  }

  onBackClick(): void {
    this.navigation_service.toBuyers();
  }

  readBuyer(buyer_id: string): void {
    this.is_read_running = true;
    this.buyers_service.readBuyer(buyer_id).subscribe({
      next: response => {
        this.buyer = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.buyer_id || '-');
  }

  onChatClick(): void {
    const phone_number = `${this.buyer?.phone?.prefix}${this.buyer?.phone?.value}`.replace(/\s/g, '');
    const whatsapp_url = `https://wa.me/${phone_number}`;
    window.open(whatsapp_url, '_blank');
  }

  onEditClick(): void {
    this.dialog_service
      .openDialog(BuyersEditDialogComponent, { buyer: this.buyer })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onRequestsClick(): void {
    this.dialog_service.openDialog(BuyersRequestsDialogComponent, {
      buyer_id: this.buyer_id,
    });
  }

  onEditCreditCardClick(): void {
    this.dialog_service
      .openDialog(BuyersEditCardDialogComponent, { buyer: this.buyer })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onConfirmBuyerClick(): void {
    this.dialog_service
      .openDialog(BuyersConfirmOtpDialogComponent, {
        buyer: this.buyer,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onUnlockBuyerClick() {
    this.dialog_service
      .openDialog(BuyersAccessControlDialogComponent, {
        buyer: this.buyer,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onToggleLockBuyer(): void {
    this.dialog_service
      .openDialog(BuyersSetBlockByAdminDialogComponent, { buyer: this.buyer })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }
        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
